import React from 'react';
import { BrowserRouter as Router, Routes, Route, } from 'react-router-dom';
import Login from '../pages/Login';
import Registration from '../pages/Registration';
import VerifyEmail from '../pages/VerifyEmail';
import ForgotPassword from '../pages/ForgotPassword';
import Test from '../pages/Test';
import DashboardLayout from '../pages/UserDashboard/DashboardLayout';
import Packages from '../pages/Packages';
import Checkout from '../pages/Checkout';

const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />

                <Route path="/test/:id" element={<Test />} />
                <Route path="/dashboard" element={<DashboardLayout />} />
                <Route path="/packages" element={<Packages />} />
                <Route path="/checkout" element={<Checkout />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;
